module.exports = __webpack_public_path__ + "0d8aaf2fb9f35dd726754b27976c7d61.png";